// CareLogix™ ORACLE — Event Intelligence API client (Phase 32A)
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const EVENT_BASE = `${BASE}/api/oracle/events`;

const http = axios.create({ baseURL: EVENT_BASE, timeout: 25_000 });

export const eventApi = {
  catalog:  () => http.get("/catalog"),
  upcoming: (params) => http.get("/upcoming", { params: params || {} }),
  byId:     (eventId, userRegion) =>
    http.get(`/event/${encodeURIComponent(eventId)}`,
      { params: userRegion ? { user_region: userRegion } : undefined }),
};

export default eventApi;
